<template>
  <div>
  <a-tree
    ref="menuTree"
    :checkable="true"
    :blockNode="true"
    :defaultExpandAll="true"
    :checkStrictly="false"
    :treeData="treeData"
    @check="handleCheck"
    :checkedKeys="value"
    :disabled="disabled"
    :expandedKeys.sync="expandedKeys"
    ></a-tree>
  </div>
</template>

<script>
  export default {
    props:{
      treeData: {
        type:Array,
        default:[]
      },
      value: {
        type:Array,
        default:[]
      },
      disabled:{
        type:Boolean,
        default:false
      },
      expandTree:{
        type:Boolean,
        default:true
      }
    },
    data(){
      return {
        allKeys:[],
        expandedKeys:[]
      }
    },
    mounted() {
      this.expandAll()
    },
    watch:{
      treeData(){
        this.expandAll()
      },
      expandTree(){
        if(this.expandTree){
          this.expandAll()
        }else{
          this.closeAll()
        }
      }
    },
    methods:{
      handleCheck (checkedKeys) {
        this.$emit("input",checkedKeys)
      },
      expandAll(){
        this.allKeys=[]
        this.pushKey(this.treeData)
        this.expandedKeys=this.allKeys
      },
      closeAll(){
        this.expandedKeys=[]
      },
      pushKey(treeData){
        treeData.forEach(item=>{
          this.allKeys.push(item.id)
          if(item.children){
            this.pushKey(item.children)
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/widget/MenuTree.vue